import { useState, useReducer, useEffect } from "react";
import { PATHS, BASE_URLS } from "./EndPoints";

let cachedData = {};

const defaultOptions = { ignoreCache: false, minimumWait: 0 };

const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_INIT":
      return {
        ...state,
        isLoading: true,
        isError: false
      };
    case "FETCH_SUCCESS":
      cachedData[action.payload.url] = action.payload.json;
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload.json
      };
    case "FETCH_FAILURE":
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    default:
      throw new Error();
  }
};

const useDataApi = (initialUrl, initialData) => {
  const [fetchState, setFetchState] = useState({
    url: initialUrl,
    options: initialData || defaultOptions
  });

  const [state, dispatch] = useReducer(dataFetchReducer, {
    isLoading: false,
    isError: false,
    data: initialData
  });

  useEffect(() => {
    let didCancel = false;
    let controller;
    let signal;

    const fetchData = async () => {
      dispatch({ type: "FETCH_INIT" });

      const { ignoreCache } = fetchState.options;

      try {
        //CACHE
        // if (!ignoreCache && cachedData[fetchState.url]) {
        //   dispatch({
        //     type: "FETCH_SUCCESS",
        //     payload: {
        //       json: cachedData[fetchState.url],
        //       url: fetchState.url
        //     }
        //   });
        //   return setFetchState({ url: null, options: null });
        // }

        controller = new AbortController();
        signal = controller.signal;
        const opts = {
          ...signal,
          ...fetchState.options
        };
        const result = await fetch(fetchState.url, opts);

        if (!didCancel) {
          const sendResult = () => {
            result
              .json()
              .then(json => {
                dispatch({
                  type: "FETCH_SUCCESS",
                  payload: { json, url: fetchState.url }
                });
              })
              .catch(() => {
                dispatch({ type: "FETCH_FAILURE" });
              })
              .finally(() => {
                signal = undefined;
                setFetchState({ url: null, options: null });
              });
          };
          const { minimumWait } = fetchState.options;
          if (minimumWait) {
            setTimeout(sendResult, minimumWait);
          } else {
            sendResult();
          }
        }
      } catch (error) {
          setFetchState({ url: null, options: null });
        if (!didCancel) {
          dispatch({ type: "FETCH_FAILURE" });
        }
      }
    };

    if (fetchState.url) {
      fetchData();
    }

    return () => {
      didCancel = true;
      if (controller) {
        controller.abort();
      }
    };
  }, [fetchState.url]);

  const doFetch = (url, options) => {
    setFetchState({
      url,
      options: Object.assign({}, defaultOptions, options)
    });
  };

  return { ...state, doFetch };
};

export { useDataApi, PATHS as API, BASE_URLS };
